exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".w_jrWE2b2u-icz2udikRM{display:inline-block;vertical-align:middle;width:1em;height:1em}._9fiU2J67uJPVP0DBdOFMW{height:100%;width:100%;fill:currentColor;vertical-align:top}", ""]);
// Exports
exports.locals = {
	"root": "w_jrWE2b2u-icz2udikRM",
	"svg": "_9fiU2J67uJPVP0DBdOFMW"
};